var state = {
  // 控制移动设备右侧导航显示与否
  mobileRightNavShow: false,
  username: '',
  /*
   用户详情数据（账号管理页面使用最多）
   {
    "id": "1025315888277671937", // 注册类型：1-手机号注册；0-邮箱注册；
    "registerType": 0, // 是否设置交易密码：1-已设置；0-未设置；
    "paymentPasswordStatus": 0, //  国际电话区号
    "countryCode": "+86", // 是否验证手机号：1-已验证；0-未验证；
    "mobileStatus": 0, // 邮箱
    "email": "9********@qq.com", // 是否完成邮箱验证：1-已验证；0：未验证；
    "emailStatus": 1, // Google认证开启状态,0,未启用，1启用
    "gaStatus": 0, // 邀请码
    "inviteCode": "URV364PVVDFL", // 是否为经纪商:1-是；0-否
    "isBroker": 0, // 会员级别
    "vipLevel": "1", // 是否是操盘账户：1-是；0-否；
    "tradeFlag": 0, // 初级认证状态：1-已完成(COMPLETED)；0-待审核(UNFINISHED)；2-未通过
    "primaryAuthStatus": "UNFINISHED", // 高级认证状态：1-已完成(COMPLETED)；0-待审核(UNFINISHED)；2-未通过
    "advancedAuthStatus": "UNFINISHED",
    // 状态：0，禁用；1，启用；
    "status": 1, // 注册IP
    "registerIp": "12*******", // 注册时间
    "created": "2018-08-03T17:42:11", // 修改时间
    "lastUpdateTime": "2018-08-03T17:42:11"
}
    */
  userInfo: {},
  userVip: {},
  token: '',
  // 当前语言
  lang: {},
  /*
    所有的语言
    [{
        "id": "1024235874265313282",
        "name": "简体中文",
        "img": "http://coinx-resource.oss-cn-shenzhen.aliyuncs.com/static/1533354727347.jpg",
        "code": "zh_CN",
        "status": 1,
        "created": "2018-07-31 18:10:36",
        "lastUpdateTime": "2018-08-04 11:52:05"
    }]
    */
  langs: [],
  assetsList: [],
  // 当前货币类型
  currency: null,
  /*
    所有的法定货币
    [{
        "id": "1",
        "abbreviation": "USD",
        "symbol": "$",
        "rate": 1,
        "img": "http://mbaex-static.oss-cn-hongkong.aliyuncs.com/static/1534698084884.jpg",
        "status": 1,
        "created": "2018-08-19T23:40:19",
        "lastUpdateTime": "2018-08-20T01:01:27"
    }]
    */
  currencies: [],
  allCoin: [],
  // token过期时间
  expireTime: '',
  // 最后更新时间
  lastUpdateTime: '',
  // 存储所有的交易市场信息，交易中心（非专业版交易、专业版交易需使用）
  marketList: [],
  // 当前交易市场
  currentMarket: {},
  // 未读消息数量
  unreadMessageCount: null,
  // 资讯研究导航，主要在详情页面使用
  infomationNav: [],
  isLogin: false,

  // 币种列表
  coinList: [],
  // 控制移动端侧滑菜单显示与隐藏
  sliderMenuControls: {
    announcement: false, // 资讯研究
    help: false, // 帮助中心
    assets: false, // 资产管理
    finance: false, // 财务明细
    usercenter: false, // 个人中心
  },
  tradingPairsList: [], // 所有币币交易对，列表
  collectedMarketSymbols: {}, // 收藏的交易对id列表
  forMobile: false, // For mobile app to use
  socketState: false, // true = connected, false = not connected
  burgerMenuState: false,
  wechatQrCode: '',
  afAndPrInfo: {},
  partnerInfo: {},
  partnerType: [],
  affiliateType: [],

  rewardCategories: [],
};
export default state;
